import React from 'react'
import PropTypes from 'prop-types'
import { FormHelperText } from '@mui/material'
import { getIn } from 'formik'
import { withStyles } from '~/themes/useStyles'
import { COLORS } from '~/themes/common'

const style = () => ({
  text: {
    color: COLORS.accent.rubyRed1,
  },
})

const ErrorText = ({ field, form, classes }) => {
  const hasError =
    !!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)
  return hasError ? (
    <>
      <input
        type="hidden"
        name={field.name}
        value={JSON.stringify(field.value)}
      />
      <FormHelperText name={field.name} className={classes.text}>
        {getIn(form.touched, field.name) && getIn(form.errors, field.name)}
      </FormHelperText>
    </>
  ) : (
    ''
  )
}

ErrorText.propTypes = {
  classes: PropTypes.shape().isRequired,
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
}

export default withStyles(style)(ErrorText)
